import {Button} from "@vkontakte/vkui";
import React from "react";
import {AdaptivityContext} from "./constants";
import { Icon20CopyOutline } from '@vkontakte/icons';

class CopyToClipBoard extends React.Component {
    copyContent = async (text) => {
        if(text) {
            try {
                await navigator.clipboard.writeText(text);
                window.postMessage({type: "success", text: "Текст скопирован в буфер обмена", timeout: 2000, hideSpinner: true})
            } catch (err) {
                window.postMessage({type: "error", text: "Ошибка записи в буфер обмена"})
            }
        }
    }

    render() {
        return true|| AdaptivityContext.copy_to_clipboard_enabled?
            (
            <div style={{cursor:'pointer', color: 'var(--vkui--color_text_primary)', padding: '0px', minWidth: "26px",  display: 'inline-block', ...this.props.style}}
                    onClick={(e) =>{e.stopPropagation(); this.copyContent(this.props.text)}} size="s"
                    mode="tertiary">
                <Icon20CopyOutline width={this.props.size ?? 24}/>
            </div>
        ):''
    }
}

export default CopyToClipBoard